import type { TileChange } from "../../types";
import { TilemapEditsManager } from "../../GameMap/TilemapEditsManager";
import type { WamFile } from "../../GameMap/WamFile";
import { Command } from "../Command";

export class PutTilesCommand extends Command {
    protected readonly tileChanges: TileChange[];

    protected wamFile: WamFile;

    constructor(wamFile: WamFile, tileChanges: TileChange[], commandId?: string) {
        super(commandId);
        this.wamFile = wamFile;
        this.tileChanges = structuredClone<TileChange[]>(tileChanges);
    }

    public execute(): Promise<void> {
        const overlay = TilemapEditsManager.getOrCreateOverlay(this.wamFile.getWam());
        overlay.tileChanges.push(...this.tileChanges);
        return Promise.resolve();
    }
}
